"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Equation_exports = {};
__export(Equation_exports, {
  default: () => Equation_default
});
module.exports = __toCommonJS(Equation_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.42188 6.5L3.99609 4.625C3.87891 4.48177 3.83333 4.32552 3.85938 4.15625C3.88542 3.97396 3.97005 3.82422 4.11328 3.70703C4.25651 3.60286 4.41276 3.5638 4.58203 3.58984C4.76432 3.61589 4.90755 3.70052 5.01172 3.84375L6.22266 5.42578L7.41406 3.84375C7.51823 3.70052 7.65495 3.61589 7.82422 3.58984C8.00651 3.5638 8.16927 3.60286 8.3125 3.70703C8.45573 3.8112 8.54036 3.95443 8.56641 4.13672C8.59245 4.31901 8.55339 4.47526 8.44922 4.60547L5.01172 9.21484C4.90755 9.35807 4.76432 9.44271 4.58203 9.46875C4.41276 9.49479 4.25651 9.44922 4.11328 9.33203C3.97005 9.22786 3.88542 9.09115 3.85938 8.92188C3.83333 8.73958 3.8724 8.57682 3.97656 8.43359L5.42188 6.5ZM13.5273 12.8281L11.7109 10.6602C11.6068 10.5299 11.5612 10.3737 11.5742 10.1914C11.5872 10.0091 11.6654 9.86589 11.8086 9.76172C11.9388 9.64453 12.0885 9.59245 12.2578 9.60547C12.4401 9.61849 12.5898 9.69661 12.707 9.83984L14.3477 11.832L16.0078 9.83984C16.125 9.69661 16.2682 9.61849 16.4375 9.60547C16.6198 9.59245 16.776 9.64453 16.9062 9.76172C17.0495 9.86589 17.1276 10.0091 17.1406 10.1914C17.1536 10.3737 17.1016 10.5299 16.9844 10.6602L15.1875 12.8281L16.9844 14.9961C17.1016 15.1393 17.1536 15.3021 17.1406 15.4844C17.1276 15.6536 17.0495 15.7969 16.9062 15.9141C16.776 16.0182 16.6198 16.0638 16.4375 16.0508C16.2682 16.0378 16.125 15.9596 16.0078 15.8164L14.3477 13.8438L12.707 15.8164C12.5898 15.9596 12.4401 16.0378 12.2578 16.0508C12.0885 16.0638 11.9388 16.0182 11.8086 15.9141C11.6654 15.7969 11.5872 15.6536 11.5742 15.4844C11.5612 15.3021 11.6068 15.1393 11.7109 14.9961L13.5273 12.8281ZM13.4297 4.87891L5.89062 16.6172C5.76042 16.8255 5.57161 16.9232 5.32422 16.9102C5.07682 16.8971 4.89453 16.7799 4.77734 16.5586L3.05859 13.1211C2.98047 12.9648 2.96745 12.8021 3.01953 12.6328C3.08464 12.4635 3.19531 12.3398 3.35156 12.2617C3.50781 12.1706 3.67057 12.1576 3.83984 12.2227C4.00911 12.2747 4.13281 12.3789 4.21094 12.5352L5.42188 14.9766L12.5312 3.88281C12.5964 3.79167 12.6745 3.72005 12.7656 3.66797C12.8568 3.61589 12.9609 3.58984 13.0781 3.58984H17.3555C17.5378 3.58984 17.6875 3.65495 17.8047 3.78516C17.9349 3.90234 18 4.05208 18 4.23438C18 4.40365 17.9349 4.55339 17.8047 4.68359C17.6875 4.8138 17.5378 4.87891 17.3555 4.87891H13.4297Z",
      fill: "currentColor"
    }
  )
);
const SvgEquation = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Equation_default = SvgEquation;
